import DefaultResetPassword from "src/components/feature/ResetPassword";
const ResetPassword = () => {
  return <DefaultResetPassword />;
};

export default ResetPassword;
